import React, { useEffect, useState } from "react";
import PageHeader1 from "../../components/common/PageHeader1";
import { DataGrid } from "@mui/x-data-grid";
import { getSubscriptionListApi } from "../../services/Subscription";
import { useForm } from "react-hook-form";

function SubscriptionList() {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [searchInput, setSearchInput] = useState("");
  const [searchTrigger, setSearchTrigger] = useState("");
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const { reset } = useForm();

  const columns = [
    { field: 'sno', headerName: 'S.No.', width: 90 },
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'email', headerName: 'Email', width: 220 },
    { field: 'mobile', headerName: 'Mobile', width: 140 },
    { field: 'planName', headerName: 'Plan', width: 180 },
    { field: 'planType', headerName: 'Period', width: 120 },
    { field: 'paidAmount', headerName: 'Amount', width: 120 },
    { field: 'startDate', headerName: 'Start Date', width: 180 },
    { field: 'expiryDate', headerName: 'Expiry Date', width: 180 },
    { field: 'status', headerName: 'Status', width: 130 },
  ];

  async function load() {
    setLoading(true);
    try {
      const resp = await getSubscriptionListApi({ page: page + 1, limit, search: searchTrigger });
      const { data = [], total: tot = 0 } = await resp;
      setTotal(tot || 0);
      setRows(
        (data || []).map((item, i) => ({
          id: item._id || `${item.userId}_${i}`,
          sno: page * limit + i + 1,
          name: item.user ? `${item.user.first_name || ''} ${item.user.last_name || ''}`.trim() : '-',
          email: item.user?.email || '-',
          mobile: item.user?.mobile || '-',
          planName: item.planName || item.planName || '-',
          planType: item.planType || '-',
          paidAmount: item.paidAmount != null ? item.paidAmount : (item.planPrice != null ? item.planPrice : '-'),
          startDate: item.startDate ? new Date(item.startDate).toLocaleString() : '-',
          expiryDate: item.expiryDate ? new Date(item.expiryDate).toLocaleString() : '-',
          status: item.status || '-',
        }))
      );
    } catch (err) {
      console.error('Error loading subscriptions', err);
    } finally {
      reset();
      setLoading(false);
    }
  }

  useEffect(() => {
    const t = setTimeout(() => {
      setSearchTrigger(searchInput);
      if (page !== 0) setPage(0);
    }, 400);
    return () => clearTimeout(t);
  }, [searchInput]);

  useEffect(() => {
    load();
  }, [page, limit, searchTrigger]);

  return (
    <div className="body d-flex py-lg-3 py-md-2">
      <div className="container-xxl">
        <PageHeader1 pagetitle="Subscriptions" />

        <div className="row clearfix g-3">
          <div className="col-sm-12 mt-3">
            <div className="card">
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-sm-12 col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by user name or email"
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                    />
                  </div>
                </div>

                <div style={{ height: 600, width: '100%' }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    loading={loading}
                    paginationMode="server"
                    rowCount={total}
                    paginationModel={{ page, pageSize: limit }}
                    onPaginationModelChange={(newModel) => {
                      setPage(newModel.page);
                      setLimit(newModel.pageSize);
                    }}
                    pageSizeOptions={[8, 10, 25, 50]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionList;
